import type { SVGProps } from 'react';
const DawnFlagLT = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-LT_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-LT_svg__a)">
      <path fill="#118357" d="M0 10.667h22V5.333H0z" />
      <path fill="#D8343D" d="M0 16h22v-5.333H0z" />
      <path fill="#FEC34B" d="M0 5.333h22V0H0z" />
    </g>
  </svg>
);
export default DawnFlagLT;
